import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAIHealthCompanionStore } from '../stores/ai-health-companion-store';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Home Dashboard',
  '/health': 'Health Overview',
  '/medical-history': 'Medical History',
  '/appointments': 'Appointments',
  '/test-results': 'Test Results',
  '/medications': 'Medications',
  '/medical-records': 'Medical Records',
  '/health-tools': 'Health Tools',
  '/health-hub': 'Health Hub',
  '/messages': 'Messages',
  '/test-catalog': 'Test Catalog',
  '/order-test': 'Order Test',
  '/schedule-appointment': 'Schedule Appointment',
  '/profile': 'Profile',
  '/settings': 'Settings',
  '/help': 'Help & Support',
  '/ai-assistant': 'AI Health Companion',
  '/ai-health-companion': 'AI Health Companion',
  '/care': 'Care',
  '/me': 'My Account',
};

/**
 * Hook that tracks the current page and updates the AI companion's
 * page context on every route change. Call this in AppShell.
 */
export function useAIPageContext(): void {
  const location = useLocation();
  const setPageContext = useAIHealthCompanionStore((state) => state.setPageContext);

  useEffect(() => {
    const path = location.pathname;
    const title = PAGE_TITLES[path] || 'KaiMed';
    setPageContext({ path, title });
  }, [location.pathname, setPageContext]);
}
